import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=5e593f8d&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=5e593f8d&prod&lang=scss&"
import style1 from "./Detail.vue?vue&type=style&index=1&id=5e593f8d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e593f8d",
  null
  
)

export default component.exports